/**
 * Token Storage Utilities
 * Gère le stockage sécurisé du refresh token
 * L'access token reste en mémoire (dans le context)
 */

const REFRESH_TOKEN_KEY = "arborescence_refresh_token";

export const getStoredRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

export const setStoredRefreshToken = (token) => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

export const clearStoredTokens = () => {
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};
